import { NARRATIVE_EDIT_BUTTON_FRAGMENT } from '@/pages/Narrative/components/NarrativeEditButton';
import { gql } from '@/utilities/gql';

export const NARRATIVE_CARD_ACTIONS_FRAGMENT = gql(
  `
  fragment NarrativeCardActionsFields on Narrative @_unmask {
    id
    isPrimary
    valuation {
      type
    }
    company {
      id
    }
    ...NarrativeEditButtonFields
  }
`,
  [NARRATIVE_EDIT_BUTTON_FRAGMENT]
);
